module.exports = __webpack_public_path__ + "img/737-767a9a.png";